import React, { Component } from 'react';

class PostImageHeader extends Component {
    render() {
        return (
            <div>
                
            </div>
        );
    }
}

export default PostImageHeader;


// WEBPACK FOOTER //
// ./src/post/elements/PostImageHeader.js